"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftOwnershipsResponseToJSON = exports.GetNftOwnershipsResponseFromJSONTyped = exports.GetNftOwnershipsResponseFromJSON = void 0;
var _1 = require("./");
function GetNftOwnershipsResponseFromJSON(json) {
    return GetNftOwnershipsResponseFromJSONTyped(json, false);
}
exports.GetNftOwnershipsResponseFromJSON = GetNftOwnershipsResponseFromJSON;
function GetNftOwnershipsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftOwnerships': (json['nftOwnerships'].map(_1.NftOwnershipFromJSON)),
    };
}
exports.GetNftOwnershipsResponseFromJSONTyped = GetNftOwnershipsResponseFromJSONTyped;
function GetNftOwnershipsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftOwnerships': (value.nftOwnerships.map(_1.NftOwnershipToJSON)),
    };
}
exports.GetNftOwnershipsResponseToJSON = GetNftOwnershipsResponseToJSON;
